// extracted by mini-css-extract-plugin
module.exports = {"container":"EsqueciSenhaOk_container__19pd6","margin":"EsqueciSenhaOk_margin__2VWZ2"};